import { useCallback, useState } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

const useGetOcrFailedMessageApi = () => {
  const [ocrFailedValue, setOcrFailedValue] = useState("");
  const call = useCallback(
    (attachmentId?: number) =>
      new Promise<string>(async (resolve, reject) => {
        try {
          const response = await axiosInstance.get<string>(
            api.getOcrFailedMessage(attachmentId as number)
          );
          setOcrFailedValue(response.data);
          resolve(response.data);
        } catch (error) {
          setOcrFailedValue("");
          reject(error);
        }
      }),
    []
  );

  const { execute, isLoading } = useAsync(call, false);
  return { getOcrFailedMassage: execute, isOcrFailedMessageLoading: isLoading, ocrFailedValue };
};

export default useGetOcrFailedMessageApi;